import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getscantagabnormals: option =>
    request('v1/scantag/getscantagabnormals', option, true, false), // 查询扫码异常记录列表
  getscantags: option => {
    const urls = querystring(option)
    return request('v1/scantag/getscantags' + urls, option, true, false) // 扫码记录
  },
  getfeedbacks: option =>
    request('v1/scantag/getfeedbacks', option, true, false), // 查询扫码反馈列表
  getfeedback: option => {
    const urls = querystring(option)
    return request('v1/scantag/getfeedback' + urls, {}, true, false) // 查询扫码反馈
  }
}
